import { useProfile } from "@shared/hooks/useProfile";
import theme from "@shared/utils/themeColors";
import { Link } from "react-router-dom";

export function FeedLeftContent() {
  const { user, getProfileThumbnail } = useProfile();

  if (!user) {
    return null;
  }

  const { profile } = user;

  return (
    <div className="w-full md:w-60 mb-8 md:mb-0">
      <div className="md:sticky md:top-16 md:h-[calc(100dvh-64px)] md:overflow-x-hidden md:overflow-y-auto no-scrollbar">
        <div className="md:py-8">
          {/* Profile */}
          <div className="text-center mb-6">
            <div className="inline-flex mb-3">
              <img
                className="w-16 h-16 rounded-full"
                src={getProfileThumbnail(profile)}
                alt={profile.name || "User"}
              />
            </div>
            <div>
              <Link
                className={`text-sm font-semibold ${theme.text.primary}`}
                to="/profile"
              >
                {profile?.name || "User"}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
